<template>
  <v-row>
    <v-col cols="12">
      <v-card class="px-0">
        <v-skeleton-loader v-if="$store.state.invoices.retrieveLoader" transition="fade-transition" type="toolbar" />
        <v-toolbar v-else color="transparent" flat height="55">
          <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">Notas de crédito</v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-row align="center" justify="center" class="mr-1">
              <v-query-builder :query-map="filters" model="invoice" class="mr-1" />
            </v-row>
          </v-toolbar-items>
        </v-toolbar>
        <v-divider />
        <v-card-text class="px-0 py-0">
          <credit-note-list />
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
import { creditNoteFilters } from '../../collections/queryBuilderFilters'

import CreditNoteList from '@/components/invoice/CreditNoteList'
import VQueryBuilder from '@/components/VQueryBuilder/VQueryBuilder'
import ListViewMixin from '@/mixins/ListViewMixin'

export default {
  components: {
    CreditNoteList,
    VQueryBuilder
  },
  mixins: [
    ListViewMixin
  ],
  data: () => ({
    filters: creditNoteFilters
  }),
  created () {
    this.$store.dispatch('generals/LIST', {
      resource: 'generals/documents',
      query: {
        country__id__in: `${this.account.country.id}, US`,
        is_sale: 'True'
      }
    })
    .then((response) => {
      if (response.data.results && response.data.results.length) {
        const index = this.filters.findIndex(filter => filter.id === 'invoice__document')
        this.filters[index].choices = response.data.results.map((document) => {
          return { label: document.name, value: document.id }
        })
      }
    })
  },
  methods: {
    getList () {
      this.$store.dispatch('invoices/LIST', {
        resource: 'creditnotes',
        query: Object.assign({}, this.$route.query, {
          expand: 'document,invoice'
        })
      })
    }
  }
}
</script>
